import React, { Component } from "react";
import Map from "../../molecules/map-component/mapComponent";
import SedeInfo from "../../molecules/sede-info/sedeInfo";
import "./mapSede.scss";

interface Props {
  sede: any;
  changePage: any;
  changeSelectedSede: any;
}

interface State {
  geolocationLat: number;
  geolocationLon: number;
  value: string;
  rotate: boolean;
}

export default class Sede extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      geolocationLat: 0,
      geolocationLon: 0,
      value: "  Mi ubicación",
      rotate: false
    };
  }

  render() {
    if (!this.props.sede) {
      return (
        <div className="error">
          <h3>No fue encontrada esa sede</h3>
          <p className="btn-primary" onClick={() => this.props.changePage("main")}>
            Volver al buscador de sedes
          </p>
        </div>
      );
    }

    const {
      name,
      hours,
      services,
      spaces,
    } = this.props.sede;

    return (
      <div className="o-sede">
        <div className="o-sede__container">
          <section className="o-sede__container__titles">
            <div className="o-sede__container__titles__subtitle" onClick={() => this.props.changePage("main")}>
              <i className="icon-arrow-alt-circle-left1"></i>
              <div className="o-sede__container__titles__subtitle__p">Volver a la lista</div>
            </div>
            <h1 className="o-sede__container__titles__main">{name}</h1>
          </section>
          <div className="o-sede__container__map">
            <Map
              sedes={[this.props.sede]}
              page="sede"
              geolocationLat={this.state.geolocationLat}
              geolocationLon={this.state.geolocationLon}
              changePage={this.props.changePage}
              changeSelectedSede={this.props.changeSelectedSede}
              center={{
                lat: this.props.sede.location.lat,
                lng: this.props.sede.location.lon,
              }}
            />
          </div>
          <section className="o-sede__container__info" >
            <SedeInfo address={this.props.sede.address ? this.props.sede.address : this.props.sede.mainAddress} phone={this.props.sede.phone.json.content[0].content[0].value.length > 0 ? this.props.sede.phone : this.props.sede.mainPhone} hours={hours} services={services} spaces={spaces} />
          </section>
        </div>
      </div>
    );
  }
}
